import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({data, tableColumns}) => {
    const columns = [
        {id: "login", label: "Agente", className: "w-[15%]", renderCell: element => element.login ?? ""},
        {id: "date_time", label: "Data/Hora", className: "w-[20%]", renderCell: element => element.date_time ?? ""},
        {id: "action", label: "Ação", className: "w-[20%]", renderCell: element => element.action ?? ""},
        {id: "session_info", label: "Informação da sessão", className: "w-[25%]", renderCell: element => element.session_info ?? ""},
        {id: "application", label: "Aplicação", className: "w-[20%]", renderCell: element => element.application ?? ""},
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Sessões de agentes`, "user-sessions-data");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 ? (
                <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>
            ) : <table id="user-sessions-data" className="table report-table" sheet-name="Sessões de agentes">
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>

                <tbody className="bg-white">
                    {data.map((element, index) => <tr key={index} className="table-break-word">{visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}</tr>)}
                </tbody>
            </table>}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;